import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-top-products',
  templateUrl: './top-products.component.html',
  styleUrls: ['./top-products.component.scss']
})
export class TopProductsComponent implements OnInit {

  @ViewChild('top_product_text', { static: true }) targetDiv!: ElementRef;
  constructor(
    public router: Router,

  ) { }

  ngOnInit(): void {
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
  }
  get targetDivId(): string {
    return this.targetDiv?.nativeElement?.id;
  }
  navigateToproduct(data:any, id:any){
    this.router.navigate(['/product'], { queryParams: { id: `${data}-id${id}` } });
  }
}
